import { MixedModelConstructedNoDates } from "@/types/types";

export const getMixedModel = (
  id: string,
  mixedModels: MixedModelConstructedNoDates[]
): MixedModelConstructedNoDates | null => {
  const foundMixedModel = mixedModels.find(
    (mixedModel) => mixedModel.id === id
  );

  if (foundMixedModel !== undefined) {
    return foundMixedModel;
  }
  return null;
};
